<script>
  import solicitacaoCompraServico from '../servico.js';
  import ListaItens from './compartilhado/FormListaItens.vue';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { ListaItens, Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoCompraServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          })
          .catch(erro => {
            let msg = erro.message;           
          });

        },
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.solicitacao.projeto.dataInicioVigencia;
        let dataTermino = this.solicitacao.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }
        
        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }
        
        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.liberacaoCoordenador) || '---';
      },
      fusp() {
        return this.configuracao.abreviaturaFundacao.toUpperCase() === 'FUSP';
      },
      habilitarOuDesabilitarTermo() {
        if (!this.fusp)
          return false;

        return this.solicitacao.itensSolicitacaoCompra.find(i => (i.tipoCompra == '13') || (i.tipoCompra == '06b') || (i.tipoCompra == '15'));
      },
      nomeAbaTermo() {
        if (this.solicitacao.itensSolicitacaoCompra.find(i => i.tipoCompra == '13' && i.executora == '2'))
          return 'Termo de responsabilidade';

        if (this.solicitacao.itensSolicitacaoCompra.find(i => (i.tipoCompra == '13' && i.executora == '1') || (i.tipoCompra == '06b') || (i.tipoCompra == '15')))
          return 'Termo liberação pagamento';

        return '';
      },
      nomePessoaTermo() {
        return this.nomeAbaTermo === 'Termo liberação pagamento' ? 'Nome (coordenador)' : 'Nome';
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Compra - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-compra';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Compra - Relatório'"></cabecalho>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Projeto</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Tipo de projeto</dt>
                    <dd>{{ solicitacao.projeto.tipoProjeto ? solicitacao.projeto.tipoProjeto.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Nr. processo</dt>
                    <dd>{{ solicitacao.projeto ? solicitacao.projeto.nrProcesso : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacaoCompra || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacaoCompra | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.pedidoPor ? solicitacao.pedidoPor.nomePessoaFisicaJuridica : '---'  }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Coordenador do projeto</dt>
                    <dd>{{ solicitacao.projeto.coordenador ? solicitacao.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Nome contato</dt>
                    <dd>{{ solicitacao.nomeSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Email contato</dt>
                    <dd>{{ solicitacao.emailSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Telefone contato</dt>
                    <dd>{{ solicitacao.telefoneSolicitante || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.liberadoPor ? solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.utilizarDetalheRateioSolicitacao">
                  <dl class="col-xs-12">
                    <dt>Detalhe rateio</dt>
                    <dd>{{ solicitacao.detalheRateio ? solicitacao.detalheRateio.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.selecaoDeContaWeb">
                  <dl class="col-xs-12">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[solicitacao.alteracaoLocalEntrega ? 'col-xs-6' : 'col-xs-12']">
                    <dt>Local de entrega</dt>
                    <dd>{{ solicitacao.localEntrega.replace(/=\|=/g, ' - ') }}</dd>
                  </dl>
                  <dl class="col-xs-6" v-if="solicitacao.alteracaoLocalEntrega">
                    <dt>Justificativa de alteração do Local de Entrega</dt>
                    <dd class="white-space-pre">{{ solicitacao.justificativaAltLocalEntrega || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Indicação de Fornecedores (Informe sempre a Razão Social e o CNPJ. Acrescente outras informações se necessário)</dt>
                    <dd class="white-space-pre">{{ solicitacao.indicacaoFornec || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-6" v-if="!configuracao.solCompraOcultarObservacoesCompras">
                    <dt>Observação solicitação</dt>
                    <dd class="white-space-pre">{{ solicitacao.observacaoSolCompras || '---' }}</dd>
                  </dl>
                </div>

                <div v-if="habilitarOuDesabilitarTermo && solicitacao.dataAssinaturaTermo">
                    <div class="hr-line-dashed margin-top-5"></div>

                    <h3 class="m-t-none m-b"> {{nomeAbaTermo}}</h3>

                    <div class="row">
                        <dl class="col-xs-4">
                            <dt>{{ nomePessoaTermo }}</dt>
                            <dd>{{ solicitacao.pessoaAssinaturaTermo || '---' }}</dd>
                        </dl>
                        <dl class="col-xs-4">
                            <dt>Documento</dt>
                            <dd>{{ solicitacao.cpfAssinaturaTermo || '---' }}</dd>
                        </dl>
                        <dl class="col-xs-4">
                            <dt>Data aceite</dt>
                            <dd>{{solicitacao.dataAssinaturaTermo | formatarData }} às {{solicitacao.dataAssinaturaTermo | formatarHora }}</dd>
                        </dl>
                    </div>

                    <div class="hr-line-dashed margin-top-5"></div>
                </div>

                <lista-itens :itens-solicitacao-compra="solicitacao.itensSolicitacaoCompra" :relatorio="true"></lista-itens>

                <div class="hr-line-dashed margin-top-5" v-if="this.configuracao.solCompraMsgConfirmacao"></div>

                <div class="row" v-if="this.configuracao.solCompraMsgConfirmacao">
                  <div class="col-md-12">
                    <p><i>{{this.configuracao.solCompraMsgConfirmacao}}</i></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/SolicitacaoCompraRelatorio.vue